module.exports = __webpack_public_path__ + "de77a722/img/SOURCERY_poweredby_web.9819842b.png";